/* eslint-disable react/jsx-indent */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Card, CardBody, Col, CardHeader,
  Row } from 'reactstrap'
import { getRegs } from '../../../utils/fc'
import { currencyFormatter } from '../../../utils/currencyFormatter'
import PqGridView from '../../Modal/PqGridView'
import moment from 'moment'
import {MaterialReactTable} from 'material-react-table'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Edit from '@material-ui/icons/Edit'
import api_powerapps from '../../../services/powerapps/index'


class Extrato extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: false,
      dataIsLoading: false,
      pqGridViewIsOpen: false,
    }
  }

  componentDidMount() {
    this.credentialsOikos()
    this.preloading()
  }

  preloading = async() => {
    this.setState({dataIsLoading: true })
    console.log("props EvePag ", this.props)
    const data = await getRegs('rec', {orcRubr_id: this.props.orcRubr_id })
    console.log("lista do EvePag ", data)
    this.setState({ data, dataIsLoading: false })
  }

  renderPmtFat = (fat) => {
    let fat_badge
    let fat_label
    switch (fat) {
      case 0:
        fat_badge = `badge badge-warning` // Pendente
        fat_label = `Não` // Pendente
        break
      case 1:
        fat_badge = `badge badge-info` // Faturado
        fat_label = `Sim` // Pendente
        break
    }
    return (<span className={fat_badge}>{fat_label}</span>)
  }

  renderPmtStatus = (risk) => {
    let fat_badge
    let fat_label
    switch (risk) {
      case 0:
        fat_badge = `badge badge-info` // Sim
        fat_label = `Sim`
        break
      default:
        fat_badge = `badge badge-warning` // Não
        fat_label = `Não`
        break
    }
    return (<span className={fat_badge}>{fat_label}</span>)
  }

  renderPmtRisk = (fat) => {
    let fat_badge
    let fat_label
    switch (fat) {
      case 0:
        fat_badge = `badge badge-info` // Pendente
        fat_label = `Pago` // Pendente
        break
      case 1:
        fat_badge = `badge badge-success` // Faturado
        fat_label = `Baixo` // Pendente
        break
      case 2:
        fat_badge = `badge badge-warning` // Faturado
        fat_label = `Médio` // Pendente
        break
      case 3:
        fat_badge = `badge badge-danger` // Faturado
        fat_label = `Alto` // Pendente
        break
        case 4:
          fat_badge = `badge badge-danger` // Faturado
          fat_label = `Não avaliado` // Pendente
          break
    }
    return (<span className={fat_badge}>{fat_label}</span>)
  }

  credentialsOikos = async() => {
    const formData = new FormData()
    console.log('buscando as credenciais do oikos')
    try {
      // início da requisição
      formData.append('acao', 'get_credentials') // objeto enviado com a requisição indicando a rota
      formData.append('user_email', this.props.auth.user.mail)
      const res = await api_powerapps.post('/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      }) // requisição propriamente dita
      console.log('login:', res.data) // debug
      this.setState({ oikos_usuario: res.data.usuario_login, oikos_senha: res.data.usuario_senha})
    } catch (err) {
      console.log('Não foi possível logar no Oikos.', err)
    }
  }


  render() {

    const { dataIsLoading, data, oikos_usuario, oikos_senha, pqGridViewIsOpen } = this.state
    //const { isManager } = this.props.auth.user
    const { mes } = this.props

    const columns = [
      {
        accessorKey: 'rec_id',
        header: 'ID',
        size: 50,
      },
      {
        accessorKey: 'rec_parc',
        header: 'Parcela',
        size: 50,
      },
      {
        accessorKey: 'rec_ep',
        header: 'Descrição',
        size: 100,
        maxWidth: 200,
      },
      {
        accessorKey: 'rec_vlrBru',
        header: 'Valor Bruto',
        accessorFn: (row) => currencyFormatter.format(row.rec_vlrBru),
        size: 50,
      },
      {
        accessorKey: 'rec_vlrLiq',
        header: 'Valor Líquido',
        accessorFn: (row) => currencyFormatter.format(row.rec_vlrLiq),
        size: 50,
      },
      {
        header: 'Faturado?',
        accessorFn: (row) => row.rec_fat,
        Cell: ({ renderedCellValue, row }) => this.renderPmtFat(renderedCellValue),
        size: 50,
      },
      {
        header: 'Pago?',
        accessorFn: (row) => row.rec_risco,
        Cell: ({ renderedCellValue, row }) => this.renderPmtStatus(renderedCellValue),
        size: 50,
      },
      {
        header: 'Risco',
        accessorFn: (row) => row.rec_risco,
        Cell: ({ renderedCellValue, row }) => this.renderPmtRisk(renderedCellValue),
        size: 50,
      },
      {
        accessorKey: 'rec_dtNfPrev',
        header: 'Limite para faturamento',
        accessorFn: (row) => moment(row.rec_dtNfPrev).format('DD/MM/YYYY'),
        size: 30,
      },
      {
        accessorKey: 'rec_dtQuitAtual',
        header: 'Previsão de pagamento',
        accessorFn: (row) => moment(row.rec_dtQuitAnual).format('DD/MM/YYYY'),
        size: 30,
      },
    ]


    if (dataIsLoading) {
      return (
        <Card>
          <CardBody>
            <span>Carregando...</span>
          </CardBody>
        </Card>
      )
    }

    //isManager
    if (data) {
      return (
          <>
          <PqGridView
            isOpen={pqGridViewIsOpen}
            Path={`https://oikos.ecoss.is/oikos/bancodedados.rec.php?orcRubr_id=${this.props.orcRubr_id}&login123=${oikos_usuario}&pass123=${oikos_senha}`}
            Header={`Receitas`}
            toggle={() => {
              this.setState({
                pqGridViewIsOpen: false,
              })
              this.preloading()
            }} />
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <CardHeader>
                    {`Extrato - ${mes}`}
                  </CardHeader>
                  <CardBody>
                    {!dataIsLoading && data?.length === 0 && (
                      `O extrato está vazio.`
                    )}
                    {!dataIsLoading && data?.length > 0 && (
                      <MaterialReactTable
                        columns={columns}
                        data={data}
                        initialState={{
                          density: 'compact',
                          expanded: false, //expand all groups by default
                          pagination: { pageIndex: 0, pageSize: 20 },
                          sorting: [{ id: 'rec_parc', desc: false }], //sort by state by default
                        }}
                        enableGrouping={false}
                        enableGlobalFilter={true}
                        enableFilters={true}
                        enablePagination={true}
                        renderTopToolbarCustomActions={() => (
                          <Box marginLef="auto">
                            <IconButton onClick= {() => this.setState({pqGridViewIsOpen: true})}>
                              <Edit />
                            </IconButton>
                          </Box>
                        )}
                        //enableRowActions={true}
                        //clicking anywhere on the row will select it
                        /*muiTableBodyRowProps={({ row }) => ({
                          onClick: () =>  {
                            const aux_row = row.original
                            this.setState(
                              {
                                modalData: {
                                  ...aux_row,
                                }
                              },
                              () => {
                                console.log('modalData state = ', this.state.modalData)
                                this.toggleModal()
                              }
                            )
                          },
                          sx: { cursor: 'pointer' },
                        })}*/
                        /*renderRowActions={({ row }) => (
                          <Box>
                            <IconButton onClick= {() => {
                                const aux_row = row.original
                                this.setState({
                                  modalData: {
                                    ...aux_row,
                                  }
                                })
                                console.log('modalData state = ', this.state.modalData)
                                this.toggleModal()
                              }
                            }>
                              <Edit />
                            </IconButton>
                          </Box>
                        )}*/
                      />
                  )}
                  </CardBody>
                </Col>
              </Row>
            </CardBody>
          </Card>

          </>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ auth: state.auth })
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Extrato)
